import { MONOLITH_ORIGIN } from "@/monolithIntegration/monolithIntegration.constants";
import useRestQuery from "@/remoteState/useRestQuery";

const useTeacherLanguageGet = (teacherId) => {
  const requestUrl = `${MONOLITH_ORIGIN}/api/v2/teacher-languages/${teacherId}/`;
  return useRestQuery(requestUrl, { skip: !teacherId });
};

export default useTeacherLanguageGet;
